const UN_DIA = 86_400_000;

/**
 * Días que quedan hasta `fin` (redondeado hacia arriba: con 4 h queda «1 día»). Negativo si
 * ya pasó; `null` sin fecha. Un solo cálculo para la banda de vencimiento, Mi empresa y las
 * misiones de la demo (recorrido 3-nov: cada una tenía el suyo).
 */
export function diasQueQuedan(
  fin: string | Date | null | undefined,
  ahora: Date = new Date()
): number | null {
  if (!fin) return null;
  const t = new Date(fin).getTime();
  if (Number.isNaN(t)) return null;
  return Math.ceil((t - ahora.getTime()) / UN_DIA);
}
